export default __webpack_public_path__ + "static/media/computer-guy.68043f7e.png";